// Only round numeric display values. Draft text and stored source dimensions stay unchanged.
export const dimensionDisplay = value => typeof value === 'number' && Number.isFinite(value) ? Number(value.toFixed(2)) : value;